import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import ConfidenceAppend from "nlib/common/ConfidenceAppend";
import React, { useState } from "react";
import SelectTaxRateInput from "nlib/common/SelectTaxRateInput";
import VendorValidation from "nlib/common/VendorValidation";

const SelectTaxRate = (props) => {
  const {
    showVendorValidation,
    value,
    audit,
    vendorId,
    disabled,
    placeholder,
    transactionId,
    onChange,
    ...restProps
  } = props;

  const { uiTexts } = useSelector(getTextsData);

  const [inputOpened, setInputOpened] = useState(false);

  const [validationOpened, setValidationOpened] = useState(false);

  return (
    <VendorValidation
      skip={!showVendorValidation || disabled}
      opened={validationOpened && !inputOpened}
      vendorId={vendorId}
      listName="taxRates"
      name="taxRate"
      entityValue={value}
      confidence={audit ? null : value?.confidence}
      setOpened={setValidationOpened}
      updateTransaction={onChange}>
      {({ iconComponent, showWarning, showCriticalWarning }) => {
        return (
          <ConfidenceAppend
            icon={iconComponent}
            confidence={audit ? null : value?.confidence}>
            <SelectTaxRateInput
              disabled={disabled}
              value={value}
              invalid={!!(value?.name && !value?.id)}
              valid={!!(value?.name && value?.id)}
              placeholder={placeholder || (!value?.name && disabled ? uiTexts.noTaxRate : undefined)}
              warning={showWarning}
              border={(showWarning || showCriticalWarning) && "warning"}
              opened={inputOpened}
              setOpened={setInputOpened}
              onChange={onChange}
              {...restProps} />
          </ConfidenceAppend>
        );
      }}
    </VendorValidation>

  );
};

export default React.memo(SelectTaxRate);
